
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DisablePromoCodeLoader extends Vue {}
